import { assoc } from 'ramda';
import { toast } from 'react-toastify';

import {
  fetchSingleService,
  createService,
  updateService,
  deleteServices,
  fetchServices,
  fetchAllServices,
  toggleServiceStatus,
  fetchServicesCategories,
  fetchServicesExport
} from './services';

import {
  setServices,
  handleServiceUpdate,
  handleLoading,
  resetServicesSelected,
  setServicesCategories,
  setServicesErrors,
  clearServicesErrors,
  clearForm
} from './actions';

import { handleExporting } from 'components/Filter/store/actions';

export const loadServices = params => dispatch => {
  const { userId, establishmentId, page, qp } = params;
  const url = `/services?page=${page}${qp}`;

  dispatch(handleLoading(true));
  dispatch(clearForm());

  return fetchServices(userId, establishmentId, url)
    .then(({ data }) => {
      dispatch(resetServicesSelected());
      dispatch(setServices(data.content, data.total));
      return data;
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadAllServices = (userId, establishmentId) => dispatch => {
  return fetchAllServices(userId, establishmentId)
    .then(({ data }) => {
      if(data?.length > 0) {
        return Promise.resolve(data);
      }

      return Promise.resolve([]);
    })
    .catch(() => {
      return Promise.reject([]);
    });
}

export const loadSingleService = (userId, establishmentId, serviceId) => dispatch => {
  dispatch(handleLoading(true));

  return fetchSingleService(userId, establishmentId, serviceId)
    .then(({ data }) => {
      const service = assoc('isUpdating', true, data);
      dispatch(handleServiceUpdate(service));
    })
    .catch(() => toast.error('Não foi possível carregar o serviço.'))
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertService = (userId, establishmentId, serviceId, params, extraProps) => dispatch => {
  dispatch(handleLoading(true));

  const {
    servicesPage,
    qp
  } = extraProps;

  if(!serviceId) {
    return createService(userId, establishmentId, params)
      .then(() => {
        toast.success('Serviço cadastrado com sucesso!');
        dispatch(clearServicesErrors());
        dispatch(loadServices({ userId, establishmentId, page: servicesPage, qp }));
        return Promise.resolve();
      })
      .catch(errors => {
        dispatch(setServicesErrors(errors));
        return Promise.reject();
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateService(userId, establishmentId, serviceId, params)
    .then(() => {
      toast.success('Serviço atualizado com sucesso!');
      dispatch(clearServicesErrors());
      dispatch(loadServices({ userId, establishmentId, page: servicesPage, qp }));
      return Promise.resolve();
    })
    .catch(errors => {
      dispatch(setServicesErrors(errors));
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const removeServices = (userId, establishmentId, serviceIds) => dispatch => {
  const data = { data: { serviceIds } };

  dispatch(handleLoading(true));

  return deleteServices(userId, establishmentId, data)
    .then(() => {
      toast.success('Serviço(s) removido(s) com sucesso!');
      dispatch(resetServicesSelected());
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const changeVisibility = (userId, establishmentId, serviceId, params) => dispatch => {
  dispatch(handleLoading(true));

  return toggleServiceStatus(userId, establishmentId, serviceId)
    .then(({ data }) => {
      if(data?.code == '07006') {
        toast.success('Serviço ativado com sucesso!');
      }

      if(data?.code == '07007') {
        toast.success('Serviço desativado com sucesso!');
      }

      dispatch(loadServices({ ...params, userId, establishmentId }));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadServicesCategories = userId => dispatch => {
  dispatch(handleLoading(true));

  return fetchServicesCategories(userId)
    .then(res => dispatch(setServicesCategories(res.data)))
    .finally(() => dispatch(handleLoading(false)));
}

export const loadServicesExport = params => dispatch => {
  dispatch(handleExporting(true));

  const { userId, establishmentId, page, qp } = params;
  const queryParams = `?page=${page}${qp}`;

  return fetchServicesExport(userId, establishmentId, queryParams)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      toast.error('Não foi possível realizar a exportação.');
      return Promise.reject({});
    })
    .finally(() => dispatch(handleExporting(false)));
}